import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    wrapping: 15,
    opacity:100
};

const pixiControlsSlice = createSlice({
    name: 'controls',
    initialState,
    reducers: {
        setWrapping: (state, action) => {
            state.wrapping = action.payload;
        },
        setOpacity: (state, action) => {
            state.opactity = action.payload;
        },
    },
});

export const { setOpacity } = pixiControlsSlice.actions;

export default pixiControlsSlice.reducer;
